<% var component = new Anvil.models.components.KeyboardWatcher(params) %>
<span anvil-component="<%- component.id %>"></span>
